import React from 'react';
import { ShieldOff, Shield, AlertTriangle, CheckCircle, XCircle, TrendingUp } from 'lucide-react';

const withoutItems = [
  { text: 'Competitors can legally replicate your brand and identity' },
  { text: 'No legal recourse for infringement in federal court' },
  { text: 'Risk of forced rebranding if another party files first' },
  { text: 'Ineligible for Amazon Brand Registry and platform protections' },
  { text: 'Diminished business valuation and investor confidence' },
];
const withItems = [
  { text: 'Exclusive, nationwide legal ownership of your brand identity' },
  { text: 'Federal court authority to pursue damages and injunctions' },
  { text: 'Priority filing date locks out future competing applications' },
  { text: 'Platform access: Amazon Brand Registry, customs enforcement' },
  { text: 'Increased enterprise value and a licensable business asset' },
];

const BeforeAfterSection = () => (
  <section className="py-24 bg-[#16231C]" data-testid="before-after-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="text-center mb-16">
        <p className="eyebrow mb-4">The Cost of Inaction</p>
        <h2 className="font-display text-4xl md:text-5xl font-bold text-[#F9F8F6] tracking-tighter">
          What happens without protection?
        </h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* WITHOUT */}
        <div className="bg-[#C85A40] rounded-3xl p-8 md:p-10 border border-white/10" data-testid="before-section">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center">
              <ShieldOff className="w-6 h-6 text-[#D5D1C8]" strokeWidth={1.5} />
            </div>
            <div>
              <p className="font-body text-xs uppercase tracking-widest text-white/70">Without Protection</p>
              <h3 className="font-display text-xl font-medium text-[#D5D1C8]">Exposed & Vulnerable</h3>
            </div>
          </div>
          <div className="space-y-4">
            {withoutItems.map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <XCircle className="w-4 h-4 text-white/90 mt-1 flex-shrink-0" strokeWidth={1.5} />
                <p className="font-body text-sm text-white/90 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
          <div className="mt-8 pt-6 border-t border-white/10 flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-[#D48B47]" strokeWidth={1.5} />
            <p className="font-body text-xs text-white/70 uppercase tracking-wider">High risk of brand theft</p>
          </div>
        </div>
        {/* WITH */}
        <div className="bg-[#1A3628]/50 rounded-3xl p-8 md:p-10" data-testid="after-section">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
              <Shield className="w-6 h-6 text-white" strokeWidth={1.5} />
            </div>
            <div>
              <p className="font-body text-xs uppercase tracking-widest text-white/70">With Federal Protection</p>
              <h3 className="font-display text-xl font-medium text-white">Secure & Authoritative</h3>
            </div>
          </div>
          <div className="space-y-4">
            {withItems.map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <CheckCircle className="w-4 h-4 text-white/80 mt-1 flex-shrink-0" strokeWidth={1.5} />
                <p className="font-body text-sm text-white/90 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
          <div className="mt-8 pt-6 border-t border-white/20 flex items-center gap-2">
            <TrendingUp className="w-4 h-4 text-white/80" strokeWidth={1.5} />
            <p className="font-body text-xs text-white/70 uppercase tracking-wider">Legally protected, commercially empowered</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BeforeAfterSection;
